var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"index"}},[_c('Header'),_c('Carousel'),(!this.isSaleSolar)?_c('BestSeller'):_vm._e(),(!this.isSaleSolar)?_c('BannerOffer'):_vm._e(),(!this.isSaleSolar)?_c('Releases'):_vm._e(),(this.isSaleSolar)?_c('ProductsSolar'):_vm._e(),_c('SearchBrand'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }